import { getProxiedServiceUrl } from 'wmic-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

const SN_UTIL_FEATURE_FLAG = 'utilFeatureFlag';

export default class UtilFeatureFlagService {
    static getAllFeatureFlags(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(SN_UTIL_FEATURE_FLAG), 'getAllFeatureFlags', [], additionalHeaders);
    }

    static getFeatureFlag(flagName, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(SN_UTIL_FEATURE_FLAG), 'getFeatureFlag', [flagName], additionalHeaders);
    }

    static isFeatureFlagActive(flagName, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(SN_UTIL_FEATURE_FLAG), 'isFeatureFlagActive', [flagName], additionalHeaders);
    }
}
